import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantEditResidencePage = {
  alert: {
    error: 'coapplicant-edit-residence.alert.error',
  },
  footer: {
    root: 'coapplicant-edit-residence.footer.root',
  },
  form: {
    addressLine1Input: 'coapplicant-edit-residence.form.address-line-1-input',
    addressLine1InputError:
      'coapplicant-edit-residence.form.address-line-1-input-error',
    addressLine2Input: 'coapplicant-edit-residence.form.address-line-2-input',
    amountInput: 'coapplicant-edit-residence.form.amount-input',
    amountInputError: 'coapplicant-edit-residence.form.amount-input-error',
    cancelButton: 'coapplicant-edit-residence.form.cancel-button',
    cityInput: 'coapplicant-edit-residence.form.city-input',
    cityInputError: 'coapplicant-edit-residence.form.city-input-error',
    h1: 'coapplicant-edit-residence.form.h1',
    h2: 'coapplicant-edit-residence.form.h2',
    monthSelect: 'coapplicant-edit-residence.form.month-select',
    monthSelectError: 'coapplicant-edit-residence.form.month-select-error',
    previousAddressLine1Input:
      'coapplicant-edit-residence.form.previous-address-line-1-input',
    previousAddressLine1InputError:
      'coapplicant-edit-residence.form.previous-address-line-1-input-error',
    previousAddressLine2Input:
      'coapplicant-edit-residence.form.previous-address-line-2-input',
    previousCityInput: 'coapplicant-edit-residence.form.previous-city-input',
    previousCityInputError:
      'coapplicant-edit-residence.form.previous-city-input-error',
    previousResidenceRoot:
      'coapplicant-edit-residence.form.previous-residence-root',
    previousStateSelect:
      'coapplicant-edit-residence.form.previous-state-select',
    previousStateSelectError:
      'coapplicant-edit-residence.form.previous-state-select-error',
    previousZipCodeInput:
      'coapplicant-edit-residence.form.previous-zip-code-input',
    previousZipCodeInputError:
      'coapplicant-edit-residence.form.previous-zip-code-input-error',
    residenceTypeSelect:
      'coapplicant-edit-residence.form.residence-type-select',
    residenceTypeSelectError:
      'coapplicant-edit-residence.form.residence-type-select-error',
    root: 'coapplicant-edit-residence.form.root',
    stateSelect: 'coapplicant-edit-residence.form.state-select',
    stateSelectError: 'coapplicant-edit-residence.form.state-select-error',
    submitButton: 'coapplicant-edit-residence.form.submit-button',
    zipCodeInput: 'coapplicant-edit-residence.form.zip-code-input',
    zipCodeInputError: 'coapplicant-edit-residence.form.zip-code-input-error',
  },
  header: {
    drawerButton: 'coapplicant-edit-residence.header.drawer-button',
    previousStepButton:
      'coapplicant-edit-residence.header.previous-step-button',
    root: 'coapplicant-edit-residence.header.root',
  },
  progress: {
    root: 'coapplicant-edit-residence.progress.root',
  },
} as const satisfies PageLocatorMap;
